<form [formGroup]="iForm" name="iForm" (ngSubmit)="submit()" class="field-sm">
    <div class="row">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Date Of Birth</mat-label>
                <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker" (click)="picker.open()" formControlName="birthDate" name="birthDate" required autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="f.birthDate.errors?.required && f.birthDate.touched">
                    Date Of Birth is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Given Name</mat-label>
                <input matInput placeholder="Given Name" formControlName="givenName" autocomplete="off" required>
                <mat-error *ngIf="f.givenName.errors?.required && f.givenName.touched">
                    Given Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Family Name</mat-label>
                <input matInput placeholder="Family Name" formControlName="familyName" autocomplete="off" required>
                <mat-error *ngIf="f.familyName.errors?.required && f.familyName.touched">
                    Family Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Registration State</mat-label>
                <mat-select formControlName="registrationState" autocomplete="off" required>
                    <mat-option *ngFor="let item of stateList" [value]="item.name">
                        <span class="bold">{{item.name}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>



        <div class="col-md-12" *ngIf="f.registrationState.value !== 'QLD' && (f.registrationState.value !== null && f.registrationState.value !== undefined)">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Registration Number</mat-label>
                <input matInput placeholder="Registration Number" formControlName="registrationNumber" autocomplete="off" required>
                <mat-error *ngIf="f.registrationNumber.errors?.required && f.registrationNumber.touched">
                    Registration Number is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-12" *ngIf="(f.registrationState.value === 'TAS' || f.registrationState.value === 'QLD') && (f.registrationState.value !== null && f.registrationState.value !== undefined)">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Registration Date</mat-label>
                <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker2" (click)="picker.open()" formControlName="registrationDate" name="registrationDate" required autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="f.registrationDate.errors?.required && f.registrationDate.touched">
                    Registration Date is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>




        <div class="col-md-12" *ngIf="f.registrationState.value === 'VIC' && (f.registrationState.value !== null && f.registrationState.value !== undefined)">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Registration Year</mat-label>
                <input matInput placeholder="YYYY" mask="0000" formControlName="registrationYear" autocomplete="off" required>
            </mat-form-field>
        </div>

        <div class="col-md-12" *ngIf="f.registrationState.value !== 'VIC' && (f.registrationState.value !== null && f.registrationState.value !== undefined)">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Certificate Number</mat-label>
                <input matInput placeholder="Certificate Number" formControlName="certificateNumber" autocomplete="off" required>
            </mat-form-field>
        </div>



        <div class="col-md-12 text-center">
            <button class="btn btn-success btn-sm bold" type="submit" [disabled]="iForm.invalid">
                Verify
            </button>
        </div>

    </div>
</form>